import { FormTemplate } from 'data/template/template.types';

const RibbonC20CSCTargetCCCTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Ribbon C20 CSC AF',
  key: 'RIBBONC20_CSC',
  tag: 'ribbon-c20-csc',
  general: {
    metadata: {
      layout: {
        rows: [
          [
            'targetDeliveryTemplate',
          ],

        ],
      },
    },
    fields: {
      targetDeliveryTemplate: {
        type: 'select',
        label: 'Target Delivery Template',
        initial: '',
        options: [],
        optionsFirstTranslatable: true,
      },
    },
  },
  usnbdTargetInformation: {
    metadata: {
      layout: {
        rows: [
          [
            'agencyid',
            'cdcid'
          ],
          [
            'assoc',
            '$empty'
          ]
        ],
      },
    },
    fields: {
      agencyid: {
        type: 'select',
        label: 'Agency ID',
        initial: '1',
        options: [
          {
            label: '1',
            value: '1',
          },
        ],
        validation: {
          required: false,
        },
      },
      cdcid: {
        type: 'select',
        label: 'CDC ID',
        initial: '1',
        options: [
          {
            label: '1',
            value: '1',
          },
        ],
        validation: {
          required: false,
        },
      },
      assoc: {
        type: 'text',
        hide: 'true',
        label: 'Associate',
        initial: '',
      },
    },
  },
  usnbdCallContentChannelInformation: {
    metadata: {
      layout: {
        rows: [
          [
            'cccid'
          ],
          [
            'definition',
            'ccraccess',
          ],
          [
            'dnsrc',
            'dndest',
          ],
          [
            'ccrindex',
            'status',
          ],
          [
            'cccassoc',
            'result',
          ],
        ],
      },
    },
    fields: {
      cccid: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      definition: {
        type: 'select',
        label: 'Definition',
        initial: 'PAIRED',
        options: [
          {
            label: 'PAIRED',
            value: 'PAIRED',
          },
          {
            label: 'COMBINED',
            value: 'COMBINED',
          }
        ],
        validation: {
          required: true,
        },
      },
      ccraccess: {
        type: 'select',
        label: 'CCR Access',
        initial: 'SW',
        options: [
          {
            label: 'SW',
            value: 'SW',
          },
          {
            label: 'DE',
            value: 'DE',
          }
        ],
        validation: {
          required: true,
        },
      },
      dnsrc: {
        type: 'text',
        label: 'Subject\'s DN',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 30,
              errorMessage: 'Exceeds maximum length, 30.  Please re-enter.',
            },
          ],
        },
      },
      dndest: {
        type: 'text',
        label: 'Associate\'s DN',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 30,
              errorMessage: 'Exceeds maximum length, 30.  Please re-enter.',
            },
          ],
        },
      },
      ccrindex: {
        type: 'text',
        hide: 'true',
        label: 'CCC Index',
        initial: '',
      },
      status: {
        type: 'text',
        hide: 'true',
        label: 'CCC Status',
        initial: '',
      },
      cccassoc: {
        type: 'text',
        hide: 'true',
        label: 'Associate',
        initial: '',
      },
      result: {
        type: 'text',
        hide: 'true',
        label: 'Result',
        initial: '',
      },
    },
  }
};

export default RibbonC20CSCTargetCCCTemplate;
